import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import colors from "../../../../../../Constants/colors";

// Function to format numbers in scientific notation
const formatToScientific = (value) => {
  // if (value === 0) return "0";
  // const exponent = Math.floor(Math.log10(Math.abs(value)));
  // const mantissa = (value / Math.pow(10, exponent)).toFixed(3);
  // return `$${mantissa} × 10^${exponent}`;
  if (value === 0) return value; // Return 0 as is

  const exponent = Math.floor(Math.log10(Math.abs(value)));
  const mantissa = (value / Math.pow(10, exponent)).toFixed(2); // Mantissa with 2 decimal places

  // If the exponent is between -2 and 2 (inclusive), return the rounded value with 2 decimal places
  if (exponent >= -2 && exponent <= 2) {
    return Number(value).toFixed(2);
  }

  // Otherwise, return the mantissa and exponent in scientific notation
  return (
    <>
      {mantissa} &times; 10<sup>{exponent}</sup>
    </>
  );
};

const BotPerformanceTable = ({ bots }) => {
  // Separate deleted bots (botName === "unknown") from active bots
  const deletedBots = bots.filter(
    (bot) => bot.botName.toLowerCase() === "unknown"
  );
  const activeBots = bots.filter(
    (bot) => bot.botName.toLowerCase() !== "unknown"
  );

  // Determine all keys (columns) based on the structure of active bots
  const allKeys = [...new Set(bots.flatMap((bot) => Object.keys(bot)))].filter(
    (key) => key !== "botName"
  );

  // Function to render table rows
  const renderTableRows = (botList) =>
    botList.map((bot, index) => (
      <TableRow
        key={index}
        sx={{
          backgroundColor: colors.darkGray, // Consistent dark background for rows
          "&:hover": {
            backgroundColor: colors.lightGray, // Hover effect
          },
        }}
      >
        <TableCell sx={{ color: "#ffffff" }}>{bot.botName}</TableCell>
        {allKeys.map((key) => (
          <TableCell key={key} sx={{ color: "#ffffff" }}>
            {formatToScientific(bot[key])}
          </TableCell>
        ))}
      </TableRow>
    ));

  return (
    <TableContainer
      component={Paper}
      sx={{
        backgroundColor: "#1e1e1e", // Dark background for the table container
        borderRadius: 2,
        boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.5)",
        padding: 2,
      }}
    >
      <Table>
        {/* Active Bots Section */}
        {activeBots.length > 0 && (
          <>
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={allKeys.length + 1}
                  sx={{
                    color: colors.extremeWhite,
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    backgroundColor: colors.secondaryBlue,
                    textAlign: "center",
                  }}
                >
                  Active Bots
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    color: colors.extremeWhite,
                    fontWeight: "bold",
                    backgroundColor: colors.secondaryBlue,
                  }}
                >
                  Bot Name
                </TableCell>
                {allKeys.map((key) => (
                  <TableCell
                    key={key}
                    sx={{
                      color: colors.extremeWhite,
                      fontWeight: "bold",
                      backgroundColor: colors.secondaryBlue,
                    }}
                  >
                    {key.replace(/([A-Z])/g, " $1").trim()}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>{renderTableRows(activeBots)}</TableBody>
          </>
        )}

        {/* Deleted Bots Section */}
        {deletedBots.length > 0 && (
          <>
            <TableHead sx={{ mt: 2 }}>
              <TableRow>
                <TableCell
                  colSpan={allKeys.length + 1}
                  sx={{
                    color: colors.extremeWhite,
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    backgroundColor: colors.secondaryBlue,
                    textAlign: "center",
                  }}
                >
                  Deleted Bots
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    color: colors.extremeWhite,
                    fontWeight: "bold",
                    backgroundColor: colors.secondaryBlue,
                  }}
                >
                  Bot Name
                </TableCell>
                {allKeys.map((key) => (
                  <TableCell
                    key={key}
                    sx={{
                      color: colors.extremeWhite,
                      fontWeight: "bold",
                      backgroundColor: colors.secondaryBlue,
                    }}
                  >
                    {key.replace(/([A-Z])/g, " $1").trim()}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>{renderTableRows(deletedBots)}</TableBody>
          </>
        )}
      </Table>
    </TableContainer>
  );
};

export default BotPerformanceTable;
